module.exports = __webpack_public_path__ + "static/media/clubs_5.eb2c609b.png";